module.exports = __webpack_public_path__ + "img/05.2b66d54d.jpg";